var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYnIconLrg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "yn_icon_lrg",
    "data-name": "Yes No Icon Large",
    d: "M27.431,4.611,4.611,27.431a2.695,2.695,0,0,0,1.958,1.958L29.4,6.569A2.782,2.782,0,0,0,27.431,4.611ZM16.833,4.5,4.5,16.833v3.931L20.764,4.5Zm-9.556,0A2.786,2.786,0,0,0,4.5,7.278v2.778L10.056,4.5Zm19.444,25A2.8,2.8,0,0,0,29.5,26.722V23.944L23.944,29.5Zm-13.486,0h3.931L29.5,17.167V13.236Z",
    transform: "translate(-4.5 -4.5)",
    fill: "#8f6aea"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYnIconLrg);
export default __webpack_public_path__ + "static/media/yn_icon_lrg.216f46a792cf41c8c8731a22fad82ddc.svg";
export { ForwardRef as ReactComponent };